"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fyShuffle = (a, b, c, d) => {
    // 피셔 에이츠 셔플 축약 코드
    c = a.length;
    while (c)
        (b = (Math.random() * (--c + 1)) | 0),
            (d = a[c]),
            (a[c] = a[b]),
            (a[b] = d);
    return a;
};
exports.default = fyShuffle;
